import Icon from '../components/Icon.vue'

Icon.register({"location-arrow":{"width":1408,"height":1792,"paths":[{"d":"M1401 349l-640 1280q-17 35-57 35-5 0-15-2-22-5-35.5-22.5t-13.5-39.5v-576h-576q-22 0-39.5-13.5t-22.5-35.5 4-42 29-30l1280-640q13-7 29-7 27 0 45 19 15 14 18.5 34.5t-6.5 39.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/location-arrow.js
// module id = RIsO
// module chunks = 0